import { mapValues, includes } from 'lodash';
import { CTCOutputModel } from '../utilities/calculator';

export const formatMoneyCTC = (rawOutput: CTCOutputModel) =>
  mapValues(rawOutput, (value: number, key: string) => {
    if (includes(['FundExhausionAge', 'growthLevel'], key)) {
      return value;
    }
    return `£${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  });

export const getCTCValues = (sliderValue: number, responses: CTCOutputModel[]) =>
  responses.filter(response => ({
    0: response.growthLevel === 'low',
    50: response.growthLevel === 'mid',
    100: response.growthLevel === 'high',
  }[sliderValue]))[0];

export const formatInputModel = (inputValue: number) =>
  `${inputValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;



// WEBPACK FOOTER //
// ./src/utilities/slider.ts